import axios from "axios";

// Bare axios instance — NO auth header. Used by tokenized public pages only.
const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const publicApi = axios.create({
  baseURL: `${BASE}/api/public`,
});

export const publicFileUrl = (path) => `${BASE}/api/public${path}`;

export function formatPublicErr(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}
